import * as React from 'react';
import { MultiItemPickerProps, MultiItemPicker } from '../MultiItemPicker';
import { MultiImagePickerNotifier } from './MultiImagePickerNotifier';

export type MultiImagePickerProps<T extends { id: number | string; src?: string; title: string }> = Omit<
    MultiItemPickerProps<T>,
    'disableNavigator' | 'renderNotifier'
>;

/**
 *
 * @param props - MultiImagePickerProps
 * @returns - MultiImagePicker
 */
export function MultiImagePicker<T extends { id: number | string; src?: string; title: string }>(
    props: MultiImagePickerProps<T>,
): JSX.Element {
    return <MultiItemPicker {...props} renderNotifier={MultiImagePickerNotifier()} />;
}
MultiImagePicker.displayName = 'MultiImagePicker';
